import axios from 'axios'
import { LISTAR_PONTOS_EMBARQUE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions'

export default function listarPontosEmbarquePorEmpresa(idEmpresa) {
  const url = `${URL}/ponto-embarque/empresa/${idEmpresa}`
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: LISTAR_PONTOS_EMBARQUE,
      payload: response
    })
  )
}
